import { IsNumber, IsString, Min } from "class-validator";

export class ProductItem {
  @IsString()
  productId: string;

  @IsNumber()
  @Min(1, { message: "Quantity must be greater than 0" })
  quantity: number;

  constructor(productId: string, quantity: number) {
    this.productId = productId;
    this.quantity = quantity;
  }

  static create(productId: string, quantity = 1): ProductItem {
    return new ProductItem(productId, quantity);
  }
}
